export default "__VITE_ASSET__5dffa10f__"